import { Component, Input, inject, HostBinding, PLATFORM_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { CountryService } from '../../core/services/utils/country.service';
import { map } from 'rxjs';

@Component({
  selector: 'app-logo-box',
  standalone: true,
  imports: [RouterModule, CommonModule],
  template: `
    <a class="navbar-brand d-flex align-items-center justify-content-between logo-brand" routerLink="/">
      <img
        class="navbar-brand-item mr-2"
        src="assets/images/logo-5.png"
        alt="Arcadia Logo"
        style="width:170px !important;height:auto !important;max-width:none !important;"
      />
    </a>
  `,
  styles: `
    :host(app-logo-box) {
      display: contents;
    }

    .logo-brand {
      position: relative;
      margin-left: 32px;
      margin-top: 6px;
      opacity: 1;
      transition: margin-top 180ms ease;
    }

    .header-sticky-on .logo-brand,
    :host(.logo-sticky-on) .logo-brand {
      margin-top: 10px;
    }

    @media (max-width: 575.98px) {
      .logo-brand {
        width: 258px;
        margin-left: -5px;
        margin-top: 0;
      }
      .header-sticky-on .logo-brand,
      :host(.logo-sticky-on) .logo-brand {
        margin-top: 0;
      }
    }
  `,
})
export class LogoBoxComponent {
  private countryService = inject(CountryService);
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  countryCode$ = this.countryService.getCountry().pipe(map((loc) => loc.countryCode));

  @HostBinding('class.logo-sticky-on') logoStickyOn = false;

  @Input() scrollThreshold: number = 400;

  private handleScroll = () => {
    this.logoStickyOn = window.scrollY > this.scrollThreshold;
  };

  constructor() {
    // `window` no existe en el prerender (Node): el scroll solo se escucha en el navegador.
    if (!this.isBrowser) return;
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    this.handleScroll();
  }

  ngOnDestroy(): void {
    if (!this.isBrowser) return;
    window.removeEventListener('scroll', this.handleScroll);
  }
}